import { useEffect } from "react";
import { useSelector } from "react-redux";
import { openModal } from "risa-oasis-ui_v2";
import { ModalId } from "../enums/modalId";
import { RootState } from "../redux/store/store";

export const useModalOpener = () => {
  const { openedModalId } = useSelector((state: RootState) => state.modal);
  useEffect(() => {
    if (openedModalId === ModalId.IMAGE_VIEWER_MODAL) {
      openModal(ModalId.IMAGE_VIEWER_MODAL);
    }
    if (openedModalId === ModalId.ADD_NEW_VIEW_TAB) {
      openModal(ModalId.ADD_NEW_VIEW_TAB);
    }
    if (openedModalId === ModalId.FINAL_DOCUMENT_MODAL) {
      openModal(ModalId.FINAL_DOCUMENT_MODAL);
    }
  }, [openedModalId]);
  return { openedModalId };
};
